import { FormControl, FormHelperText, FormLabel, Input } from "@mui/joy";
import { useController, useFormContext } from "react-hook-form";

// A time of day with no date or timezone, held as "HH:mm". The API sends "HH:mm:ss", so a value
// is trimmed to the minutes for the native input.
export default function TimeInput({
  name,
  label,
  disabled,
}: {
  name: string;
  label: string;
  disabled?: boolean;
}) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ name, control });
  return (
    <FormControl error={Boolean(fieldState.error)}>
      <FormLabel>{label}</FormLabel>
      <Input
        type="time"
        disabled={disabled}
        value={typeof field.value === "string" ? field.value.slice(0, 5) : ""}
        onChange={(event) => field.onChange(event.target.value || null)}
        onBlur={field.onBlur}
      />
      {fieldState.error?.message ? (
        <FormHelperText>{fieldState.error.message}</FormHelperText>
      ) : null}
    </FormControl>
  );
}
